// 賞品応募資格を得るために必要な最低エリアクリア数を定義
export const PRIZE_MIN_AREA_CLEAR = {
  SS: 19, // 当選確率2倍
  S: 15, // S・A・B・C賞に応募可能
  A: 10, // A・B・C賞に応募可能
  B: 5, // A・B・C賞に応募可能
  C: 1, // C賞に応募可能
};
